import { useCMSPageField } from '@/cms/fields'
import CheckoutSection from '@/scopes/checkout/components/CheckoutSection'
import { useCheckoutSid, usePriceOverviews } from '@/scopes/checkout/domain/hooks'
import { Banner, space, SpaceBetween, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'
import { getIconForService } from '../ServiceIcon'
import { BreakDownTable } from './BreakDownTable'
import { MandatoryCosts } from './MandatoryCost'

const Texts = styled(SpaceBetween)`
  flex: 1;
  gap: ${space('primitives_space_4')};
`

export function CheckoutPriceOverview(props: { glyph: string, type: 'PriceOverview' | 'PriceOverviewPerPerson' }) {
  const { glyph, type } = props
  const sid = useCheckoutSid()
  const priceOverview = (useCMSPageField('Checkout.items')?.items ?? []).find(item => item.type === type)
  const { data, isLoading } = usePriceOverviews(priceOverview?.componentId)

  if (!sid) {
    return null
  }

  if (!priceOverview) {
    return ''
  }

  if (isLoading)
    return ''
  if (!data)
    return ''

  return (
    <CheckoutSection title={priceOverview.componentTitle ?? ''} glyph={getIconForService(glyph)}>
      <SpaceBetween spacing={space('primitives_space_16')} direction="y">
        {data.warningMessage && (
          <Banner $type="info">
            <Texts direction="y">
              {data.warningMessage && <Typography dangerouslySetInnerHTML={{ __html: data.warningMessage }} />}
            </Texts>
          </Banner>
        )}
        <BreakDownTable items={data.items ?? []} />
      </SpaceBetween>
      <MandatoryCosts mandatoryCosts={data?.mandatoryCosts ?? []} mandatoryHeader={data?.mandatoryCostHeader ?? ''} />
    </CheckoutSection>
  )
}
